import { render, staticRenderFns } from "./PsiFormElement.vue?vue&type=template&id=ec0e6e66&"
import script from "./PsiFormElement.vue?vue&type=script&lang=js&"
export * from "./PsiFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec0e6e66')) {
      api.createRecord('ec0e6e66', component.options)
    } else {
      api.reload('ec0e6e66', component.options)
    }
    module.hot.accept("./PsiFormElement.vue?vue&type=template&id=ec0e6e66&", function () {
      api.rerender('ec0e6e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormElement.vue"
export default component.exports